import { AppBox, AppText } from "../../../../commons/components";
import { ManageFootballTeam } from "../../../../commons/models/football/admin/manage-football-team";

interface TeamDeleteProps {
  team: ManageFootballTeam;
}
export default function TeamDeleteInprogress({ team }: TeamDeleteProps) {
  return (
    <AppBox flexDirection="column" gap="sm">
      <AppText>
        Deleting <strong>“{team.name}”</strong> In Progress
      </AppText>
      <AppBox className="loader-line"></AppBox>
    </AppBox>
  );
}
